import {
  AccessCodeParams,
  CheckAccessCodeParams,
  CheckEmailParams,
  CheckMembershipType,
  FormType,
  GenderFormType,
  LoginTypes,
  PasswordType,
  RefCodeResponse
} from 'types';

import { get, post } from './axios';

const URLS = {
  login: 'cl-login',
  register: 'cl-register',
  checkMember: 'cl-check-member',
  sendAccessCode: 'cl-send-access-code',
  checkAccessCode: 'cl-check-access-code',
  checkEmail: 'cl-reg-email-check',
  getRegFormFields: 'cl-reg-form-fields',
  checkRefCode: 'cl-reg-check-ref-code',
  updateRefCode: 'update-cl-ref'
};

const authApi = {
  login: (params: LoginTypes) => post(URLS.login, params),
  checkMember: (params: CheckMembershipType) => post(URLS.checkMember, params),
  sendAccessCode: (params: AccessCodeParams) =>
    get(URLS.sendAccessCode, params),
  checkAccessCode: (params: CheckAccessCodeParams) =>
    get(URLS.checkAccessCode, params),
  createAccount: (
    params: FormType & PasswordType & GenderFormType & RefCodeResponse
  ) => post(URLS.register, params),
  checkEmail: (params: CheckEmailParams) => get(URLS.checkEmail, params),
  getRegFormFields: () => get(URLS.getRegFormFields),
  checkRefCode: (ref_code: string) => post(URLS.checkRefCode, { ref_code }),
  updateRefCode: ({ ld_ref_type, ld_ref_acct }: RefCodeResponse) =>
    get(URLS.updateRefCode, { ld_ref_type, ld_ref_acct })
};

export default authApi;
